const { __ } = wp.i18n;

export const NORMAL_HOVER = [
	{ label: "Normal", value: "normal" },
	{ label: "Hover", value: "hover" },
];

export const TEXT_TRANSFORM = [
	{ label: __("None"), value: "none" },
	{ label: __("Lowercase"), value: "lowercase" },
	{ label: __("Capitalize"), value: "capitalize" },
	{ label: __("Uppercase"), value: "uppercase" },
];

export const FONT_WEIGHTS = [
	{ label: __("Default"), value: "default" },
	{ label: __("Light"), value: "300" },
	{ label: __("Normal"), value: "400" },
	{ label: __("Medium"), value: "500" },
	{ label: __("Semi Bold"), value: "600" },
	{ label: __("Bold"), value: "700" },
	{ label: __("Extra Bold"), value: "800" },
	{ label: __("Heavy Bold"), value: "900" },
];

export const TEXT_DECORATION = [
	{ label: __("Initial"), value: "initial" },
	{ label: __("Overline"), value: "overline" },
	{ label: __("Line Through"), value: "line-through" },
	{ label: __("Underline"), value: "underline" },
	{ label: __("Underline Oveline"), value: "underline overline" },
];

export const COLORS = [
	{ name: 'Black', color: '#000000' },
	{ name: 'Cyan bluish gray', color: '#abb8c3' },
	{ name: 'White', color: '#ffffff' },
	{ name: 'White Gray', color: '#f2f5f7' },
	{ name: 'Vivid red', color: '#cf2e2e' },
	{ name: 'Luminous vivid orange', color: '#ff6900' },
	{ name: 'Luminous vivid amber', color: '#fcb900' },
	{ name: 'Light green cyan', color: '#7bdcb5' },
	{ name: 'Vivid green cyan', color: '#00d084' },
	{ name: 'Pale cyan blue', color: '#8ed1fc' },
	// { name: 'Vivid cyan blue', color: '#3593e3' },
	// { name: 'Vivid purple', color: '#9b51e0' },
];

export const STYLE_OPTIONS = [
	{ value: '1', label: __('Style 1', 'classified-listing') },
	{ value: '2', label: __('Style 2', 'classified-listing') },
	{ value: '3', label: __('Style 3', 'classified-listing') },
];

export const CURRENCY_POSITION = [
	{ value: 'left', label: __('Left', 'classified-listing') },
	{ value: 'right', label: __('Right', 'classified-listing') },
];

export const BORDER_STYLES = [
	{ label: __("None"), value: "none" },
	{ label: __("Solid"), value: "solid" },
	{ label: __("Dashed"), value: "dashed" },
	{ label: __("Dotted"), value: "dotted" },
	{ label: __("Double"), value: "double" },
	{ label: __("Groove"), value: "groove" },
	{ label: __("Inset"), value: "inset" },
	{ label: __("Outset"), value: "outset" },
	{ label: __("Ridge"), value: "ridge" },
];

export const CONTENT_ALIGNMENT = [
	{ value: 'left', label: __('Left', 'classified-listing') },
	{ value: 'center', label: __('Center', 'classified-listing') },
	{ value: 'right', label: __('Right', 'classified-listing') },
];

export const BTNTYPE = [
	{ value: 'custom', label: __('Custom Link', 'classified-listing') },
	{ value: 'page', label: __('Pricing Page Link', 'classified-listing') },
];